import { API_URL } from "lib/constants";
import { sendHttpRequest } from "lib/fetcher";

export function getUserForAdmin(
  name: string,
  accountName: string,
  limit: number,
  offset: number,
  id?: string,
  email?: string,
) {
  return sendHttpRequest({
    url: `${API_URL}/user/users?page.limit=${limit}&page.offset=${offset}&name=${name}&accountName=${accountName}&id=${id}&email=${email}`,
    method: "GET",
  });
}

export async function loginForAdmin(userId) {
  return await sendHttpRequest({
    method: "post",
    url: "/auth/login/as_user",
    data: {
      userId,
    },
  });
}
export async function activateUserForAdmin(userId) {
  return await sendHttpRequest({
    method: "post",
    url: "/user/users/send_activate_email",
    data: {
      userId,
    },
  });
}
export function retrieveFreeGoods() {
  return sendHttpRequest({
    url: `/goods?ret_free=true`,
    method: "GET",
  });
}
export function retrieveSiteList(orgId) {
  return sendHttpRequest({
    url: "/site/tree",
    method: "GET",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function retrieveCameraList(siteId, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras?page.limit=200&siteId=${siteId}`,
    method: "GET",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function addFreeLicense(data) {
  return sendHttpRequest({
    url: "/license/free",
    method: "POST",
    data,
  });
}
export function aiSwitch(enableAgi, orgId) {
  return sendHttpRequest({
    url: "/ai/org/settings",
    method: "POST",
    data: {
      enableAgi,
      orgId,
    },
  });
}
